import { motion } from "framer-motion";
import {MotionUtils} from "../../../utils/motionUtils";

export interface DashboardLoadingProps {
  isLoading: boolean;
}

export default function DashboardLoading(props: Readonly<DashboardLoadingProps>) {
  return (
    <motion.div className={`n-overlay ${props.isLoading && 'show'}`} variants={MotionUtils.overlay} >
      <div className="n-ol-inner1">
        <p className="icon">
          <i className="xi-spinner-5 xi-spin"></i>
        </p>
        <p className="txt">데이터를 조회 중입니다.</p>
      </div>
    </motion.div>
  );
}